export default __webpack_public_path__ + "static/media/alert-msg.5b9ecb19.wav";